interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  hideQuestionCount?: boolean;
}

export function ProgressBar({ currentStep, totalSteps, hideQuestionCount = false }: ProgressBarProps) {
  const getProgressPercentage = (): number => {
    // If we're on the last question, always show 100%
    if (currentStep === totalSteps) {
      return 100;
    }

    // Otherwise calculate based on current position and total questions
    return Math.round((currentStep / totalSteps) * 100);
  };

  return (
    <div className="mb-6">
      <div className={`flex ${hideQuestionCount ? "justify-end" : "justify-between"} items-center mb-2`}>
        {!hideQuestionCount && (
          <span className="text-sm font-medium text-gray-700">
            Question {Math.max(1, Math.min(currentStep, totalSteps))} of{" "}
            {totalSteps}
          </span>
        )}
        <span className="text-sm font-medium text-primary-600">
          {getProgressPercentage()}% Complete
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2.5 md:h-3">
        <div
          className="bg-primary-600 h-2.5 md:h-3 rounded-full transition-all duration-300 ease-in-out"
          style={{ width: `${getProgressPercentage()}%` }}
        ></div>
      </div>
    </div>
  );
}
